import { CUSTOM_TERM_FILTER } from '@/constants';
import Vue from 'vue';

export function hasCustomTerm(value: string) {
  if (value.indexOf(CUSTOM_TERM_FILTER) > -1) {
    const filteredText = value
      .split(`' ${CUSTOM_TERM_FILTER}`)[0]
      .substring(1);
    return filteredText;
  }
  return null;
}

export function customTermsFilter(value: string) {
  const customTermCheck = hasCustomTerm(value);
  if (customTermCheck !== null) return Vue.filter('customTerm')(customTermCheck);
  return value;
}